export default "__VITE_PUBLIC_ASSET__a442321e__"